import Footer from "../Footer";
import Header from "../Header";
import PageNotFoundSvg from '../assets/img/404.svg'

export const PageNotFound = () => {
  return (
    <div className="body">
      <Header />

      <div className="wrapper">
        <main className="page">
          <section className="content">
            <div className="container-fix-width">
              <div className="page-404-wrap">
                <img src={PageNotFoundSvg} alt="image" />
                <h1>Oops, This Page Could Not Be Found.</h1>
                <p>The page you are looking for might have been removed had its name changed or is temporarily unavailable.</p>
                <a href="/" className='main-btn'>
                  Back to Homepage
                </a>
              </div>
            </div>
          </section>
        </main>
      </div>

      <Footer />
    </div>
  )
}

export default PageNotFound;
